import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { createCatagory as createCategory } from '../../../redux/categoriesSlice';
import AddEditCategories from './AddEditCategories';
import SuccessModal from '../../../components/Modals/SuccessfulModal';

const CategoriesStepProgressForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isAdded, setIsAdded] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const actionType = location.state?.actionType || 'add';
  const [formData, setFormData] = useState({});

  useEffect(() => {
    // Redirect to the category listing after creation or editing
    if (isAdded) {
      navigate('/product-category');
    }
  }, [isAdded, navigate]);

  // Function to handle form submission
  const handleFormSubmit = (data) => {
    setFormData(data);
    dispatch(createCategory(data))
      .then(() => {
        setIsAdded(true);
      })
      .catch((error) => {
        console.error('Failed to create or edit category:', error);
      });
  };

  return (
    <>
      <div className="main-content">
        <nav aria-label="breadcrumb" className="bread-box">
          <div>
            <h1 className="fprimary">{actionType === 'edit' ? 'Edit Category' : 'Add Category'}</h1>
            <h5>{actionType === 'edit' ? 'Edit category details carefully.' : 'Add category details.'}</h5>
          </div>
        </nav>

        <div className="card mt-3 bg-stage">
          <div id="multi-step-form">
            <AddEditCategories
              onSubmit={handleFormSubmit}
              initialValues={formData.category}
              actionType={actionType}
            />
          </div>
        </div>
      </div>

      {isAdded && (
        <SuccessModal
          isOpen={isAdded}
          msg="Category created successfully"
          navigatePage="/product-category"
        />
      )}
    </>
  );
};

export default CategoriesStepProgressForm;
